import spartaCinemaUtility from '@sparta.global.utilities/cinema-utility/dist/es6.js';
import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import spartaUILayersUtility from '@sparta.global.utilities/sparta-ui-layers-utility/dist/es6.js';
import '@sparta.global.vendors/lodash';
import Handlebars from '@sparta.global.vendors/handlebars';
import { cinemaHelper } from '@sparta.global.helpers/cinema-helper/dist/es6.js';
import { picture } from '@sparta.global.helpers/picture-helper/dist/es6.js';
import { layerContent } from '@sparta.global.helpers/sparta-helper/dist/es6.js';
import { button } from '@sparta.global.helpers/button-helper/dist/es6.js';

const Template$1 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div class=\"row small-collapse large-uncollapse\">\r\n    <div class=\"columns small-12 medium-10 medium-offset-1\">\r\n      <div class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__wrapper\">\r\n        <div class=\"flex-wrapper "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"textRight")),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":33},"end":{"line":5,"column":86}}})) != null ? stack1 : "")
    + "\">\r\n          <div class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__text-wrapper\">\r\n            <p class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__text-quote\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"testimonial") : depth0)) != null ? lookupProperty(stack1,"quote") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n          </div>\r\n          <div class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__picture-wrapper\">\r\n            "
    + container.escapeExpression((lookupProperty(helpers,"picture")||(depth0 && lookupProperty(depth0,"picture"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"testimonial") : depth0)) != null ? lookupProperty(stack1,"picture") : stack1),{"name":"picture","hash":{},"data":data,"loc":{"start":{"line":10,"column":12},"end":{"line":10,"column":43}}}))
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"videoModalCtaBtn") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":12},"end":{"line":13,"column":19}}})) != null ? stack1 : "")
    + "          </div>\r\n        </div>\r\n\r\n        <div class=\"row collapse hide-for-large-up\">\r\n          <div class=\"columns small-12\">\r\n            <div class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__picture-wrapper\">\r\n              "
    + container.escapeExpression((lookupProperty(helpers,"picture")||(depth0 && lookupProperty(depth0,"picture"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"testimonial") : depth0)) != null ? lookupProperty(stack1,"picture") : stack1),{"name":"picture","hash":{},"data":data,"loc":{"start":{"line":20,"column":14},"end":{"line":20,"column":45}}}))
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"videoModalCtaBtn") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":21,"column":14},"end":{"line":23,"column":21}}})) != null ? stack1 : "")
    + "            </div>\r\n          </div>\r\n          <div class=\"columns small-12\">\r\n            <div class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__text-wrapper\">\r\n              <h3 class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__text-quote\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"testimonial") : depth0)) != null ? lookupProperty(stack1,"quote") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"layerContent") : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":36,"column":2},"end":{"line":44,"column":9}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    return "flex-row-reverse";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"play-button"),depth0,{"name":"play-button","data":data,"indent":"              ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"play-button"),depth0,{"name":"play-button","data":data,"indent":"                ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"layerContent")||(depth0 && lookupProperty(depth0,"layerContent"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"layerContent") : depth0),{"name":"layerContent","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":37,"column":4},"end":{"line":43,"column":21}}})) != null ? stack1 : "");
},"9":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <div class=\"video-content row\">\r\n        <div class=\"columns small-12\">\r\n          "
    + ((stack1 = (lookupProperty(helpers,"cinemaHelper")||(depth0 && lookupProperty(depth0,"cinemaHelper"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"layerContent") : depth0)) != null ? lookupProperty(stack1,"modalVideoContent") : stack1),{"name":"cinemaHelper","hash":{},"data":data,"loc":{"start":{"line":40,"column":10},"end":{"line":40,"column":59}}})) != null ? stack1 : "")
    + "\r\n        </div>\r\n      </div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"data1") : depth0),{"name":"with","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":45,"column":9}}})) != null ? stack1 : "");
},"usePartial":true,"useData":true});
const renderTemplate$1 = function (data, options) {
  return Template$1(data, options);
};

const Template = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"button")||(depth0 && lookupProperty(depth0,"button"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"videoModalCtaBtn") : depth0),{"name":"button","hash":{},"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":29}}})) != null ? stack1 : "")
    + "\r\n<!--\r\n<svg id=\"play-button\" class=\"play-button\" data-name=\"play-button-svg\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\">\r\n  <title>\r\n    bofa_icon_play2_186rgb\r\n  </title>\r\n  <path\r\n    class=\"play-button--"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"playButtonColor") || (depth0 != null ? lookupProperty(depth0,"playButtonColor") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"playButtonColor","hash":{},"data":data,"loc":{"start":{"line":8,"column":24},"end":{"line":8,"column":43}}}) : helper)))
    + "\"\r\n    d=\"M3.5,3.656l8.034,4.229L19.353,12l-7.819,4.115L3.5,20.344V3.656M2.5,2V22L12,17l9.5-5L12,7,2.5,2Z\"\r\n  ></path>\r\n  <rect style=\"fill: none\" width=\"24\" height=\"24\"></rect>\r\n</svg>\r\n-->\r\n";
},"useData":true});
const renderTemplate = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.falcon.modules/testimonials-module",
  "version": "1.0.7",
  "id": "testimonialsModule",
  "containerID": "falconTestimonialsModule",
  "moduleName": "falcon-testimonials-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "testimonials-module",
  "data": {
    "init": "TestimonialsModule",
    "options": {}
  },
  "moduleParams": [{
    "name": "textRight",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "Places the text on the right (large-view only)"
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate$1(context, {
      "helpers": {
        cinemaHelper,
        picture,
        layerContent,
        button
      },
      "partials": {
        "play-button": renderTemplate
      }
    });
  },
  "template": renderTemplate$1,
  "partials": {
    "play-button": renderTemplate
  },
  "helpers": {
    cinemaHelper,
    picture,
    layerContent,
    button
  },
  "dependencies": {
    "@sparta.falcon.utilities/style-utility": "^1.0.0",
    "@sparta.global.helpers/cinema-helper": "^3.0.0",
    "@sparta.global.utilities/cinema-utility": "^3.0.0",
    "@sparta.global.helpers/picture-helper": "^1.0.0",
    "@sparta.global.helpers/sparta-helper": "^1.0.0",
    "@sparta.global.helpers/button-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-events-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-ui-layers-utility": "^1.0.0",
    "@sparta.global.vendors/handlebars": "^4.7.7",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.global.vendors/lodash": "^4.17.21"
  },
  "stores": []
};

/* global falconDependencyManager */

const VIDEO_MODAL_ID = 'testimonialVideoLayer';

/**
 * The TestimonialsModule Sparta Module.
 * @class
 */
class TestimonialsModule extends Module {
  /**
   * Creates an instance of TestimonialsModule.
   * @param {Object} options options
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    this.videoCtaEl = this.settings.target.querySelector('#testimonialVideoLayer');
    this.playButton = this.settings.target.querySelectorAll('.testimonials-module__picture-wrapper .play-button');
  }

  /**
   * Called when this module is bootstrapped by the client.
   * @returns {undefined}
   */
  init() {
    this.cinemaUtilityInitialized = false;
    if (this.videoCtaEl) {
      spartaEventsUtility.sub(spartaUILayersUtility.EVENTS.MODAL_OPENED, ({
        data
      }) => {
        if (data && data.contentId === VIDEO_MODAL_ID && !this.cinemaUtilityInitialized) {
          spartaCinemaUtility.init('sendMoneyVideo');
          spartaEventsUtility.sub(spartaUILayersUtility.EVENTS.MODAL_CLOSED, ({
            data
          }) => {
            if (data && data.contentId === VIDEO_MODAL_ID && !this.cinemaUtilityInitialized) {
              spartaCinemaUtility.destroyVideo('spaCinema_sendMoneyVideo');
            }
          });
          this.cinemaUtilityInitialized = true;
        }
      });
    }
    if (this.playButton) {
      const pagePath = window.location.pathname;
      this.playButton.forEach(bttn => {
        bttn.setAttribute('data-page-path', pagePath);
      });
    }
  }
}
registerModuleClass({
  moduleClass: TestimonialsModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { TestimonialsModule as default, moduleConfig };
